import { BillingSettings } from "@/components/billing/BillingSettings"
import { MembershipRoles } from "@/types/User"
import { BeakerIcon, CreditCardIcon, EnvelopeIcon, UsersIcon } from "@heroicons/react/24/outline"
import { useEffect } from "react"
import { Link, Route, Routes, useLocation, useNavigate } from "react-router-dom"
import { useApp } from "../AppProvider"
import { EmailSettings } from "../components/emails/EmailSettings"
import { TestConfigTable } from "../components/testConfig/TestConfigTable"
import { EditUser } from "../components/users/EditUser"
import { UserList } from "../components/users/UserList"
import { classNames } from "../utils/classNames"

export const SettingsPage = () => {
  const { membership, orgId } = useApp()
  const navigate = useNavigate()
  const { pathname } = useLocation()

  useEffect(() => {
    if (membership?.role !== MembershipRoles.Admin) {
      navigate("/")
    }

    if (pathname.endsWith("/settings")) {
      navigate(`/organizations/${orgId}/settings/users`)
    }
  }, [membership?.role, navigate, pathname])

  const routes = [
    { title: "Users", href: `/organizations/${orgId}/settings/users`, icon: UsersIcon },
    { title: "Email", href: `/organizations/${orgId}/settings/email`, icon: EnvelopeIcon },
    { title: "Lab Values", href: `/organizations/${orgId}/settings/lab-values`, icon: BeakerIcon },
    { title: "Billing", href: `/organizations/${orgId}/settings/billing`, icon: CreditCardIcon },
  ]

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-6">
      <nav className="card flex flex-col md:col-span-2 lg:col-span-1">
        <div className="text-lg font-semibold text-gray-900">Settings</div>
        <ul className="-mx-2">
          {routes.map((route) => (
            <li key={route.title}>
              <Link
                to={route.href}
                className={classNames(
                  pathname.includes(route.href)
                    ? "text-primary-600 bg-gray-50"
                    : "hover:text-primary-600 text-gray-600 hover:bg-gray-50",
                  "group flex items-center gap-x-2.5 rounded-md p-2 text-sm leading-6 font-semibold",
                )}>
                <route.icon
                  className={classNames(
                    pathname.includes(route.href)
                      ? "text-primary-600"
                      : "group-hover:text-primary-600 text-gray-500",
                    "h-5 w-5 shrink-0",
                  )}
                  aria-hidden="true"
                />
                {route.title}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      <div className="md:col-span-4 lg:col-span-5">
        <Routes>
          <Route path="/email/*" element={<EmailSettings />} />
          <Route path="/lab-values" element={<TestConfigTable orgId={orgId} />} />
          <Route path="/users/:userId" element={<EditUser />} />
          <Route path="/users" element={<UserList orgId={orgId} />} />
          <Route path="/billing" element={<BillingSettings />} />
          <Route path="/" element={<UserList orgId={orgId} />} />
        </Routes>
      </div>
    </div>
  )
}
